const localServerApi = LOCAL_SERVER_API?`${LOCAL_SERVER_API}:4000`:"http://localhost:4000"
const PROD_BACKEND_URI = BACKEND_URI||localServerApi
const backendUri = process.env.NODE_ENV==="production"?PROD_BACKEND_URI:localServerApi

module.exports = {
  backendUri,
  projNum:0,
  onLoginRedirect:'/admin/dashboard',
  assigneeOther:'Others',
  guestRules:{
    name:'guest',
    admin:false,
    password:'no password for guest',
    rules:{
      general:  [ 'none'],
      dashboard:  [ 'none'],
      kanban: [ 'none']
    },

  },
  socketMsg:{
    crmCompanyContact:"companies crm updated",
    crmDeals:"deals updated",
    ACTIVITIES_CRM_UPDATED:'activities crm updated',
  }
};
